import { Link } from "react-router-dom";

import "../styles/FourHFooter.css";

export default function FourHFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="fourHFooter">
      <nav
        className="fourHFooterLinks"
        aria-label="FourH footer navigation"
      >
        <Link to="/fourh">
          FourH Home
        </Link>

        <Link to="/terms">
          Terms
        </Link>

        <Link to="/privacy">
          Privacy
        </Link>
      </nav>

      <p className="fourHFooterCopyright">
        © {currentYear} Kenneth L. Powell. All rights reserved.
      </p>
    </footer>
  );
}